import { combineReducers } from 'redux';
import { isLoadingReducer } from 'store/reducerUtils';
import { updateAppSettings } from './actions';

const isUpdating = isLoadingReducer(updateAppSettings);

export const appConfiguration = combineReducers({
    isUpdating,
});
